import React, { useEffect, useState } from 'react'
import AccessCardTable from './AccessCardTable'
import AccessCardFilterOptions from './AccessCardFilterOptions'
import OCard from '../../../components/ReusableComponent/OCard'
import { useAppDispatch, useTypedSelector } from '../../../stateStore'
import { reduxServices } from '../../../reducers/reduxServices'
import usePermissionToView, {
  PermissionEnum,
} from '../../../middleware/hooks/usePermissionToView'
import usePermissionAccess from '../../../middleware/hooks/usePermissionAccess'
import { usePagination } from '../../../middleware/hooks/usePagination'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import OLoadingSpinner from '../../../components/ReusableComponent/OLoadingSpinner'
import { LoadingType } from '../../../types/Components/loadingScreenTypes'
import useRouteHistory from '../../../middleware/hooks/useRouteHistory'

const expectedOrigin = ['/accessCardList']

export function AccessCardRouteLogic(): void {
  const { route } = useRouteHistory()
  const dispatch = useAppDispatch()

  const getStatus = useTypedSelector(
    reduxServices.accessCardDetails.selectors.selectedEmploymentStatus,
  )

  useEffect(() => {
    if (expectedOrigin.includes(`/${route}`)) {
      dispatch(
        reduxServices.accessCardDetails.actions.changeSelectedEmploymentStatus(
          getStatus,
        ),
      )
    } else {
      dispatch(
        reduxServices.accessCardDetails.actions.changeSelectedEmploymentStatus(
          'Active',
        ),
      )
    }
  }, [route])
}

const AccessCardDetails = (): JSX.Element => {
  usePermissionToView('AccessCard List', PermissionEnum.View)
  const permissions = usePermissionAccess()
  const userAccess = permissions.accessibility('AccessCard List')
  const dispatch = useAppDispatch()
  const [toggle, setToggle] = useState<string>('')
  const [searchInput, setSearchInput] = useState<string>('')

  const isLoading = useTypedSelector(
    reduxServices.accessCardDetails.selectors.getIsLoading,
  )

  const selectedEmploymentStatus = useTypedSelector(
    reduxServices.accessCardDetails.selectors.selectedEmploymentStatus,
  )
  const accessCardListSize = useTypedSelector(
    reduxServices.accessCardDetails.selectors.listSize,
  )

  const {
    paginationRange,
    setPageSize,
    setCurrentPage,
    currentPage,
    pageSize,
  } = usePagination(accessCardListSize, 20)

  useEffect(() => {
    dispatch(
      reduxServices.accessCardDetails.getAccessCardsList({
        startIndex: pageSize * (currentPage - 1),
        endIndex: pageSize * currentPage,
        searchStr: searchInput || '',
        country: 'India',
        status: selectedEmploymentStatus,
      }),
    )
  }, [currentPage, dispatch, pageSize, selectedEmploymentStatus])

  useEffect(() => {
    setCurrentPage(1)
    setPageSize(20)
  }, [])
  return (
    <>
      {toggle === '' && (
        <OCard
          className="mb-4 myprofile-wrapper"
          title="Access Card List"
          CBodyClassName="ps-0 pe-0"
          CFooterClassName="d-none"
        >
          <AccessCardFilterOptions
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            pageSize={pageSize}
            setPageSize={setPageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          {/* <CRow className="d-md-flex justify-content-md-end">
            <CCol
              lg={12}
              className="gap-4 d-flex justify-content-end mt-3 mb-3"
              data-testid="exportBtn"
            >
              {getAccessCardsData?.length > 0 && (
                <CButton
                  color="primary"
                  className="text-white btn-ovh"
                  size="sm"
                  onClick={handleExportAccessCardData}
                >
                  <i className="fa fa-plus me-1"></i>
                  Click to Export
                </CButton>
              )}
            </CCol>
          </CRow>
          <CRow className="gap-2 d-md-flex justify-content-md-end">
            <CCol sm={4} md={4} xl={3} lg={4}>
              <CInputGroup className="global-search me-0 justify-content-md-end">
                <CFormInput
                  data-testid="searchField"
                  placeholder="Multiple Search"
                  aria-label="Multiple Search"
                  aria-describedby="button-addon2"
                  id="searchInput"
                  name="searchInput"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value)
                  }}
                  onKeyDown={searchButtonHandlerOnKeyDown}
                />
                <CButton
                  disabled={!searchInput}
                  data-testid="multi-search-btn"
                  className="cursor-pointer"
                  type="button"
                  color="primary"
                  id="button-addon2"
                  onClick={searchButtonHandler}
                >
                  <i className="fa fa-search"></i>
                </CButton>
              </CInputGroup>
            </CCol>
          </CRow> */}
          {isLoading !== ApiLoadingState.loading ? (
            <>
              <AccessCardTable
                paginationRange={paginationRange}
                setPageSize={setPageSize}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                pageSize={pageSize}
                setToggle={setToggle}
                userAccess={userAccess}
              />
            </>
          ) : (
            <>
              <OLoadingSpinner type={LoadingType.PAGE} />
            </>
          )}
        </OCard>
      )}
    </>
  )
}

export default AccessCardDetails
